const systemBanner = {
  admin: {
    enabled: 'Afficher la bannière',
    level: 'Gravité',
    level_info: 'Information',
    level_warning: 'Avertissement',
    level_critical: 'Critique',
    template: 'Modèle',
    template_params: 'Paramètres du modèle',
    template_params_hint:
      'Les valeurs saisies remplacent les {{espaces réservés}} du message du modèle sélectionné.',
    preview: 'Aperçu (langue actuelle)',
  },
  validation: {
    invalid_template: 'Le modèle sélectionné n’est plus disponible.',
    template_required: 'Choisissez un modèle.',
    invalid_datetime: 'Saisissez une date et une heure valides.',
    invalid_number: 'Saisissez un nombre valide.',
  },
};

export default systemBanner;
